import React, { useState, useEffect } from "react";
import Moment from "react-moment";
import "./invoice.scss";

function Invoice({ invoice }) {
  const {
    businessclient: 
          client = {
          address: {},
          contacts: [],
          bankaccounts: [],
        },
    sequenceNumber,
    country,
    IBAN,
    variableSymbol,
    VAT_total = 0,
    NETTO_total = 0,
    BRUTTO_total = 0,
    actionSourceId = "",
    paymentType = "",
    currency,
    dates = {},
    customer_internal={},
    customer={
      companyName:'',
      firstName:'',
      lastName:''
    },
    items = [],
    shipTo ={
      street:'',
      streetNr:'',
      country:'',
      postcode:''
    }
  } = invoice;

  // console.log(shipTo)

  const [clientBankAccount, setClientBankAccount] = useState({});
  const [clientCompanyIds, setClientCompanyIds] = useState({});
  const [intenalCustomerIds, setIntenalCustomerIds] = useState({});


  useEffect(() => {
    if (
      client &&
      client.bankaccounts &&
      client.bankaccounts.length &&
      currency
    ) {

      console.log(client.bankaccounts,currency)
      const bankAccount = client.bankaccounts.find(
        ({ currency }) => currency === currency
      );
      console.log('found bank account:')
      setClientBankAccount(bankAccount);
    }
  }, [client]);


  useEffect(() => {
    if (client && client.companyids && client.companyids.length && country) {
      const companyIds = client.companyids.find(
        (coid) => coid.country === country
      );

      setClientCompanyIds(companyIds);

      if (customer_internal && customer_internal.companyids && customer_internal.companyids.length && country) {
        const intenalcustomerIds = customer_internal.companyids.find(
        (coid) => coid.country === country
      );
        setIntenalCustomerIds(intenalcustomerIds)}
    }
  }, [client]);

  return (
    <>
      <div className="invoice-box" id="invoice">
        <div className="invoice-wrapper">
          <header>
            <h1>Invoice</h1>
            <span>{sequenceNumber}</span>
           {!invoice.sequenceNumber && <span>PROFORMA</span>}
          </header>
          {/* <!-- Main Table --> */}
          <section className="main-table">
            {/* <!-- Col 1 --> */}
            <div className="main-table__col">
              {/* Suplier */}
              <div className="main-table__cell">
                <div>Supplier:</div>
                <div className="supplier-info">
              
                  {/* <div className="supplier__logo">
                    <img
                      src="data:image/png;base64,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"
                      alt="logo"
                    />
                  </div> */}
                  {client.address && (
                    <div className="supplier__address">
                      <div className="supplier__name text_bold text_large">
                            {client.name}
                          </div>
                      <span className="text_large">
                        {client.address.street || ""}{" "}
                        {client.address.streetNr || ""} <br />
                        {client.address.postcode || ""}{" "}
                        {client.address.city || ""}
                        <br />
                        {client.address.country || ""}
                        <br />
                      </span>
                      ID: {clientCompanyIds && clientCompanyIds.coid}
                      <br />
                      VAT: {clientCompanyIds && clientCompanyIds.taxid}
                      { client.contacts.length>0  && <div>email:{client.contacts[0].email} </div> }
                    </div>
                  )}
                </div>
              </div>
              {/* Bank */}
              <div className="main-table__cell bank">
                <table className="bank-table">
                  <tbody>
                    <tr>
                      <td>Bank:</td>
                      <td>{clientBankAccount && clientBankAccount.bankname}</td>
                    </tr>
                   {/* {clientBankAccount.accountNr&& <tr>
                      <td>Bank account:</td>
                      <td className="black-outline">
                        {clientBankAccount && clientBankAccount.accountNr} / {clientBankAccount.bankCode}
                      </td>
                    </tr>} */}
                    <tr>
                      <td>IBAN:</td>
                      <td>{IBAN}</td>
                    </tr>
                    {clientBankAccount.SWIFT&&<tr>
                      <td>BIC:</td>
                      <td>{clientBankAccount && clientBankAccount.SWIFT}</td>
                    </tr>}
                  </tbody>
                </table>
              </div>
              {/* Payment */}
              <div className="main-table__cell main-table__cell_last">
                <table className="payment-table">
                  <tbody>
                    <tr>
                      <td>Form of payment:</td>
                      <td>{paymentType}</td>
                    </tr>
                    <tr>
                      <td>Order ID:</td>
                      <td className="text_bold">
                        {actionSourceId.clientOrderNr}
                      </td>
                    </tr>
                    <tr>
                      <td>Var.sym</td>
                      <td>{variableSymbol || sequenceNumber}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            {/* <!-- Col 2 --> */}
            <div className="main-table__col">
              {/* Client Adress */}
              <div className="main-table__cell">
                <div className="col2__table">
                  <div className="col2__label">
                    Customer:
                  </div>
                  {customer &&  (
                    <div>
                      <span className="text_bold text_medium customer-address">
                        {customer.companyName} {customer.firstName} {customer.lastName}
                        <br />
                        {customer.street} {customer.streetNr}
                        <br />
                        {customer.postcode} {customer.city}
                        <br />
                        {customer.country}
                        <br />
                      </span>
                      {customer.taxId &&
                        "VAT: " + customer.taxId}
                        <br></br>
                      {customer.companyId &&
                        "ID: " + customer.companyId}
                      {/* DIC: CZ03150917 */}
                    </div>
                  )}
                {customer_internal.address && (
                  
                    <div className="supplier__address">
                       <div className="supplier__name text_bold text_large">
                          {customer_internal.name}
                        </div>
                      <span className="text_large">
                        {customer_internal.address.street || ""}{" "}
                        {customer_internal.address.streetNr || ""} <br />
                        {customer_internal.address.postcode || ""}{" "}
                        {customer_internal.address.city || ""}
                        <br />
                        {customer_internal.address.country || ""}
                        <br />
                      </span>
                      VAT: {intenalCustomerIds && intenalCustomerIds.coid}
                      <br />
                      VAT: {intenalCustomerIds && intenalCustomerIds.taxid}
                      { customer_internal.contacts.length>0  && <div>email:{customer_internal.contacts[0].email} </div> }
                    </div>
                  )}
                </div>
              </div>
              {/* Shipping */}
              <div className="main-table__cell main-table__cell_shipping">
                <div className="col2__table">
                  <div className="col2__label">Shipping Address:</div>
                  <span className="text_bold text_large shipping-address">
                    
                    {shipTo.street} {shipTo.streetNr}
                    <br />
                    {shipTo.postcode} {shipTo.city}
                    <br />
                    {shipTo.country} <br />
                  </span>
                </div>
              </div>

              {/* Payment Dates */}
              <div className="main-table__cell main-table__cell_last main-table__cell_payment-dates ">
                <div className="payment-dates__grid">
                  <span className="payment-dates__label">Issue Date:</span>
                  <span className="payment-dates__date">
                    {dates && dates.issuedDate && (
                      <Moment format="DD.MM.YYYY">
                        {dates && dates.issuedDate}
                      </Moment>
                    )}
                  </span>

                  <span className="payment-dates__label">Due Date:</span>
                  <span className="black-outline payment-dates__date">
                    {dates && dates.issuedDate && (
                      <Moment format="DD.MM.YYYY">
                        {dates && dates.dueDate}
                      </Moment>
                    )}
                  </span>

                  <span className="payment-dates__label">
                    Date of taxable supply:
                  </span>
                  <span className="payment-dates__date">
                    {dates && dates.issuedDate && (
                      <Moment format="DD.MM.YYYY">
                        {dates && dates.taxDate}
                      </Moment>
                    )}
                  </span>
                </div>
              </div>
            </div>
          </section>

          {/* Items, Prices */}
          <section className="items">
            <table className="products-table">
              <thead>
                <tr className="text_bold">
                  <th className="item-name">Deliveries designation:</th>
                  <th>Quantity</th>
                  <th>NETTO Price</th>
                  <th>VAT Rate</th>
                  <th>NETTO Total</th>
                  <th>BRUTTO Total</th>
                </tr>
              </thead>
              <tbody>
                {items.map(
                  (
                    {
                      
                      name,
                      quantity,
                      // price,
                      netto_price,
                      // unit,
                      VAT_procent,
                      // VAT_amount,
                      netto_total,
                      brutto_total,
                    },
                    i
                  ) => (
                    <tr key={i}>
                      <td className="item-name">
                        {name}
                      </td>
                      <td>{quantity}</td>
                      <td>{netto_price.toFixed(4)}</td>
                      <td>{VAT_procent}</td>
                      <td>{netto_total.toFixed(4)}</td>
                      <td>{brutto_total.toFixed(4)}</td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
          </section>

          {/* Recapitulation */}
          <section className="recapitulation">
            <div className="recap-tables">
              <table className="recap-tables__second">
                <tbody>
                  <tr>
                    <td>VAT Total</td>
                    <td>{VAT_total.toFixed(4)}</td>
                  </tr>
                  <tr>
                    <td>NETTO Total</td>
                    <td>{NETTO_total.toFixed(4)}</td>
                  </tr>
                  <tr>
                    <td>BRUTTO Total</td>
                    <td>
                      {BRUTTO_total.toFixed(4)} {currency}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <div className="signature"></div>
        </div>
      </div>
    </>
  );
}

export default Invoice;
